<div class="header">
	<div class="block-1" [routerLink]="['/']">
		<mat-icon class="icon-size-24 arrow-left" (click)="backBtnClick()" svgIcon="backArrow"></mat-icon>
		<mat-icon class="icon" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="block-2">
		<a href="javascript:void(0)"><img src="./assets/images/header/h-google.png" alt="Google Icon"></a>
		<a href="javascript:void(0)"><img src="./assets/images/header/h-apple.png" alt="App Store Icon"></a>
	</div>
</div>
<div id="login-container">
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 form">
		<div class="titles">
			<h3 class="reset-password">{{title}}</h3>
			<p class="message">{{subtitle}}</p>
		</div>
		<ng-container *ngIf="!termAndConditionBlock">
			<!-- <div class="tabs">
				<span [class.selected]="selectedTab === 'email'" (click)="selectedTab = 'email'">Email</span>
				<span [class.selected]="selectedTab === 'mobile'" (click)="selectedTab = 'mobile'">Mobile</span>
			</div> -->

			<div class="form-container">
				<!--For email registration-->
				<form [formGroup]=form (autocomplete)="'false'" (submit)="onSubmit(form)">
					<div class="col-sm-12 px-0">
						<div class="col-sm-2 px-0 form-group">
							<label>Title<sup class="error">*</sup></label>
							<app-select
								[values]="[{value:'Mr', label:'Mr'}, {value: 'Mrs', label: 'Mrs'}, {value: 'Ms', label: 'Ms'}]"
								[selectedValue]=form.value.title [style]="'none'"
								(onValueChange)="form.controls.title.setValue($event);markTouchedAndDirty($event, 'title', form)"></app-select>
							<p class="error"
								*ngIf="form.get('title')?.invalid && (form.get('title')?.dirty || form.get('title')?.touched)">
								Please select Title
							</p>
						</div>
						<div class="col-sm-5 form-group first-input-block">
							<label>First Name<sup class="error">*</sup></label>
							<app-input (onChangeEvent)="form.controls.firstName.setValue($event)"
								(onFocusOutEvent)="markTouchedAndDirty($event, 'firstName', form)"
								[value]="form.value.firstName"></app-input>
							<p class="error"
								*ngIf="form.get('firstName')?.invalid && (form.get('firstName')?.dirty || form.get('firstName')?.touched)">
								Please enter valid First Name
							</p>
						</div>
						<div class="col-sm-5 form-group px-0">
							<label>Last Name<sup class="error">*</sup></label>
							<app-input (onChangeEvent)="form.controls.lastName.setValue($event)"
								(onFocusOutEvent)="markTouchedAndDirty($event, 'lastName', form)"
								[value]="form.value.lastName"></app-input>
							<p class="error"
								*ngIf="form.get('lastName')?.invalid && (form.get('lastName')?.dirty || form.get('lastName')?.touched)">
								Please enter valid Last Name
							</p>
						</div>
					</div>
					<div class="form-group">
						<label>Mobile<sup class="error">*</sup></label>
						<div class="prefix-container">
							<span>+91</span>
							<app-input class="input" (onChangeEvent)="form.controls.mobile.setValue($event)"
								(onFocusOutEvent)="markTouchedAndDirty($event, 'mobile', form)"
								[value]="form.value.mobile"></app-input>
						</div>
						<p class="error"
							*ngIf="form.get('mobile')?.invalid && (form.get('mobile')?.dirty || form.get('mobile')?.touched)">
							<!-- Please enter valid Mobile, (with prefix +91) -->
							Please enter valid Mobile
						</p>
					</div>
					<div class="form-group">
						<label>Email Address (Optional)<sup class="error"></sup></label>
						<app-input (onChangeEvent)="form.controls.emailId.setValue($event)"
							(onFocusOutEvent)="markTouchedAndDirty($event, 'emailId', form)"
							[value]="form.value.emailId"></app-input>
						<!-- <p class="error"
							*ngIf="form.get('emailId')?.invalid && (form.get('emailId')?.dirty || form.get('emailId')?.touched)">
							Please enter valid Email address
						</p> -->
					</div>
					<div class="form-group">
						<label>Password (Optional)<sup class="error"></sup></label>
						<app-input :type="password" (onChangeEvent)="form.controls.password.setValue($event)"
							(onFocusOutEvent)="markTouchedAndDirty($event, 'password', form)"
							[value]="form.value.password"></app-input>
						<p class="error"
							*ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)">
							Please enter valid Password
						</p>
					</div>
					<div class="col-12 forgot-password-block">
						<!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
							<app-light-checkbox
								[value]="form.value.subscribeToNewsletter"
								[checked]=form.value.subscribeToNewsletter
								[text]="'Subscriber out newsletter'"
								(onChangeEvent)="form.controls.subscribeToNewsletter.setValue($event);markTouchedAndDirty($event, 'subscribeToNewsletter', form)"
							></app-light-checkbox>
							<p class="error"
							   *ngIf="form.get('subscribeToNewsletter')?.invalid && (form.get('subscribeToNewsletter')?.dirty || form.get('subscribeToNewsletter')?.touched)">
								Please select this field
							</p>
						</div>-->

						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
							<app-light-checkbox [value]="form.value.tnc" [checked]=form.value.tnc
								[text]="'I agree to the T&C and Privacy Policy'"
								(onChangeEvent)="markTouchedAndDirty(true, 'tnc', form);termAndConditionBlock = true"></app-light-checkbox>
							<p class="error"
								*ngIf="form.get('tnc')?.invalid && (form.get('tnc')?.dirty || form.get('tnc')?.touched)">
								Please select this field
							</p>
						</div>

						<!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
							<app-light-checkbox
								[value]="form.value.whatsAppUpdates"
								[checked]=form.value.whatsAppUpdates
								[text]="'Get updates on Whatsapp'"
								(onChangeEvent)="form.controls.tnc.setValue($event);markTouchedAndDirty($event, 'whatsAppUpdates', form)"
							></app-light-checkbox>
							<p class="error"
							   *ngIf="form.get('whatsAppUpdates')?.invalid && (form.get('whatsAppUpdates')?.dirty || form.get('whatsAppUpdates')?.touched)">
								Please select this field
							</p>
						</div>-->
					</div>
					<div class="col-12 text-center login-btn-block">
						<button [disabled]="!form.value.tnc" type="submit" mat-button class="btn btn-block">Register
							Now
						</button>
					</div>
					<!--<div class="col-12 text-center login-btn-google-block">
						<button type="button" mat-button class="btn btn-block" >Login via Google</button>
					</div>-->
				</form>

				<!--For mobile registration-->
				<!-- <form *ngIf="selectedTab === 'mobile'" [formGroup]=form1 (autocomplete)="'false'"
					(submit)="onSubmit(form1)">
					<div class="col-sm-12 px-0">
						<div class="col-sm-2 px-0 form-group">
							<label>Title<sup class="error">*</sup></label>
							<app-select
								[values]="[{value:'Mr', label:'Mr'}, {value: 'Mrs', label: 'Mrs'}, {value: 'Ms', label: 'Ms'}]"
								[selectedValue]=form1.value.title [style]="'none'"
								(onValueChange)="form1.controls.title.setValue($event);markTouchedAndDirty($event, 'title', form1)"></app-select>
							<p class="error"
								*ngIf="form1.get('title')?.invalid && (form1.get('title')?.dirty || form1.get('title')?.touched)">
								Please select Title
							</p>
						</div>
						<div class="col-sm-5 form-group first-input-block">
							<label>First Name<sup class="error">*</sup></label>
							<app-input (onChangeEvent)="form1.controls.firstName.setValue($event)"
								(onFocusOutEvent)="markTouchedAndDirty($event, 'firstName', form1)"
								[value]="form1.value.firstName"></app-input>
							<p class="error"
								*ngIf="form1.get('firstName')?.invalid && (form1.get('firstName')?.dirty || form1.get('firstName')?.touched)">
								Please enter valid First Name
							</p>
						</div>
						<div class="col-sm-5 form-group px-0">
							<label>Last Name<sup class="error">*</sup></label>
							<app-input (onChangeEvent)="form1.controls.lastName.setValue($event)"
								(onFocusOutEvent)="markTouchedAndDirty($event, 'lastName', form1)"
								[value]="form1.value.lastName"></app-input>
							<p class="error"
								*ngIf="form1.get('lastName')?.invalid && (form1.get('lastName')?.dirty || form1.get('lastName')?.touched)">
								Please enter valid Last Name
							</p>
						</div>
					</div>
					<div class="form-group">
						<label>Mobile<sup class="error">*</sup></label>
						<app-input (onChangeEvent)="form1.controls.mobile.setValue($event)"
							(onFocusOutEvent)="markTouchedAndDirty($event, 'mobile', form1)"
							[value]="form1.value.mobile"></app-input>
						<p class="error"
							*ngIf="form1.get('mobile')?.invalid && (form1.get('mobile')?.dirty || form1.get('mobile')?.touched)">
							Please enter valid Mobile, (with prefix +91)
						</p>
					</div>
					<div class="col-12 forgot-password-block"> -->
				<!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
							<app-light-checkbox
								[value]="form1.value.subscribeToNewsletter"
								[checked]=form1.value.subscribeToNewsletter
								[text]="'Subscriber out newsletter'"
								(onChangeEvent)="form1.controls.subscribeToNewsletter.setValue($event);markTouchedAndDirty($event, 'subscribeToNewsletter', form1)"
							></app-light-checkbox>
							<p class="error"
							   *ngIf="form1.get('subscribeToNewsletter')?.invalid && (form1.get('subscribeToNewsletter')?.dirty || form1.get('subscribeToNewsletter')?.touched)">
								Please select this field
							</p>
						</div>-->

				<!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
							<app-light-checkbox [value]="form1.value.tnc" [checked]=form1.value.tnc
								[text]="'I agree to the T&C and Privacy Policy'"
								(onChangeEvent)="markTouchedAndDirty(true, 'tnc', form1);termAndConditionBlock = true"></app-light-checkbox>
							<p class="error"
								*ngIf="form1.get('tnc')?.invalid && (form1.get('tnc')?.dirty || form1.get('tnc')?.touched)">
								Please select this field
							</p>
						</div> -->

				<!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
							<app-light-checkbox
								[value]="form1.value.whatsAppUpdates"
								[checked]=form1.value.whatsAppUpdates
								[text]="'Get updates on Whatsapp'"
								(onChangeEvent)="form1.controls.tnc.setValue($event);markTouchedAndDirty($event, 'whatsAppUpdates', form1)"
							></app-light-checkbox>
							<p class="error"
							   *ngIf="form1.get('whatsAppUpdates')?.invalid && (form1.get('whatsAppUpdates')?.dirty || form1.get('whatsAppUpdates')?.touched)">
								Please select this field
							</p>
						</div>-->
				<!-- </div>
					<div class="col-12 text-center login-btn-block">
						<button [disabled]="!form1.value.tnc" type="submit" mat-button class="btn btn-block">Register
							Now
						</button>
					</div> -->
				<!--<div class="col-12 text-center login-btn-google-block">
						<button type="button" mat-button class="btn btn-block" >Login via Google</button>
					</div>-->
				<!-- </form> -->
			</div>
		</ng-container>
		<ng-container *ngIf="termAndConditionBlock">
			<div class="terms-condition-body">
				<p>This document is an electronic record in terms of Information Technology Act, 2000 and
					rules there under as applicable and the amended provisions pertaining to electronic
					records in various statutes as amended by the Information Technology Act, 2000. This
					electronic record is generated by a computer system and does not require any physical or
					digital signatures.</p>
				<p>This document is published in accordance with the provisions of Rule 3 (1) of the
					Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the
					rules and regulations, privacy policy and user agreement for access or usage
					of www.ausmit.in website and mobile application.</p>
				<p>Ausmit is a Trade Name used by Ausmit Technology Private Limited</p>
				<h2 class="heading">User Agreement</h2>
				<p>This User Agreement contains rules and regulations, policies, terms & conditions and
					agreement applicable to any person who may access or use www.ausmit.in or mobile
					application, including any subdomains, webpages or extension of www.ausmit.in; you
					hereby agree and acknowledge to be bound by the terms of this User Agreement.</p>
				<p>The use of www.ausmit.in and the services provided are subject to the rules and
					regulations, policies, notices, terms & conditions set forth in this User Agreement. For the
					purposes of this User Agreement, ‘User’ and wherever the context may require ‘You’ (or
					any variation thereof), shall mean any natural or legal person who has agreed to become a
					user of Ausmit by accessing or browsing the Website and/or has registered as a member
					of Ausmit by submitting identification information/ registration details using the computer
					system of Ausmit and accepting the electronic record of the User Agreement.</p>
				<br />
				<h2 class="heading">Definitions</h2>
				<p> <span style="font-weight: bold;"> Payment on Billing</span> shall mean a Transaction where
					the payment for the items purchased is paid through the (i) Ausmit authorised Payment Gateway
					Facility or (ii) the
					buyer has to deposit the Transaction Price in the bank account of the AUSMIT TECHNOLOGY PRIVATE
					LIMITED by way of cash, cheque, demand draft or any other mode of payment and such
					payment of the Transaction Price is credited to the bank account of the AUSMIT
					TECHNOLOGY PRIVATE LIMITED within [3] days of booking the Transaction.</p>

				<p><span style="font-weight: bold;">Payment on Delivery</span> shall mean a Transaction where the
					payment for the
					items is collected
					from the buyer by the Logistics Partner at the time of delivering the goods. In this case, the
					Buyer shall only make payment in cash and no other mode of payment will be accepted.
					However, this facility is available only in limited cities in India and the AUSMIT
					TECHNOLOGY PRIVATE LIMITED in its sole discretion and without notice, reserves the right
					to add or withdraw the cities in which such option may be available. This facility shall not
					be available for delivery of items outside India.</p>

				<p><span style="font-weight: bold;">Delivery / Delivered</span> means physical delivery of the items to
					the buyer
					(for which a
					Transaction Price has been paid by the buyer by Payment on Billing or the buyer has opted
					for Payment on Delivery, or such other mode of payment approved by the AUSMIT
					TECHNOLOGY PRIVATE LIMITED) through a reputed courier service or by the Logistics
					Partner at the address communicated by the buyer on Ausmit website or application.</p>

				<p><span style="font-weight: bold;">In Transit/ Dispatched</span> all mean that the items (for which a
					Transaction
					Price has been paid
					by the buyer by Payment on Billing or the buyer has opted for Payment on Delivery, or
					such other mode of payment approved by the AUSMIT TECHNOLOGY PRIVATE LIMITED)
					have been dispatched through a reputed courier service or by the Logistics Partner at the
					address communicated by the buyer on Ausmit website or application.</p>

				<p><span style="font-weight: bold;">Dispatch Details</span> means the true, accurate and valid data,
					information,
					details or
					documents as specified by the AUSMIT TECHNOLOGY PRIVATE LIMITED from time to time,
					which the Logistics Partner is obligated to provide to the AUSMIT TECHNOLOGY PRIVATE
					LIMITED as proof that the item has been Dispatched and/or Delivered, as the case maybe.</p>

				<p><span style="font-weight: bold;">Information</span> means and shall include any confidential and/or
					personally
					identifiable
					information or other information provided to the AUSMIT TECHNOLOGY PRIVATE LIMITED
					or other Users of Ausmit at the time of registration, buying or listing process or through any
					email feature and shall include without limitation your name, email address,
					billing/shipping address, phone number and banking / financial information.</p>

				<p><span style="font-weight: bold;">Issuing Bank</span> in respect of a buyer, means any bank that has
					issued a Valid
					Card (credit/
					debit/ cash card) to the buyer or the branch of a bank which maintains a valid Bank
					Account in the name of buyer; with which the buyer makes payment of the Transaction
					Price. [Currently, Ausmit authorised Payment Gateway Facility supports online bank
					transfers from the banks that are available while selecting prepay as the payment method.
					The AUSMIT TECHNOLOGY PRIVATE LIMITED may add or remove or suspend any one or
					more banks directly or through any payment gateway facilitators, and such change shall
					come into effect upon the same being posted on Ausmit.]</p>

				<p><span style="font-weight: bold;">Logistics Partner</span> shall mean reputable logistics and courier
					AUSMIT
					TECHNOLOGY
					PRIVATE LIMITED(s) appointed by the AUSMIT TECHNOLOGY PRIVATE LIMITED that will
					provide various services of collection and delivery of items, collection of the Transaction
					Price from the buyer in case of Payment on Delivery Transactions or such other services
					that the AUSMIT TECHNOLOGY PRIVATE LIMITED may require.</p>

				<p><span style="font-weight: bold;">Transaction</span> means every electronically generated valid
					purchase order
					placed by the
					Buyer for purchasing the items listed on Ausmit.</p>

				<p><span style="font-weight: bold;">Transaction Price</span> means the price to be paid for the items to
					be purchased
					by the buyer for
					every Transaction and which price shall include, if applicable, the shipping charges,
					insurance charges and all other taxes, duties, costs, charges and expenses in respect
					thereof as charged by the website.</p>

				<p><span style="font-weight: bold;">Valid Card</span> means any valid credit card/ valid debit card/
					valid cash card
					or any other card
					of whatsoever nature issued by Visa or MasterCard and/or by any Issuing Bank or any
					institution designated to issue such cards and lawfully owned by the User of the card at the
					time of the Transaction as well as at the time of Refund, if any.</p>

				<p><span style="font-weight: bold;">Ausmit authorised Payment Gateway facility</span>
					means the automated electronic payment or
					collection and remittance facility provided by the AUSMIT TECHNOLOGY PRIVATE LIMITED
					to Buyers to facilitate purchase and sale of items as well as making payments there for on
					Ausmit directly through banks or financial institution infrastructure or indirectly through
					payment gateway facility providers or through any such facility authorized by the Reserve
					Bank of India to provide enabling support facility for collection and remittance of payment.
					[Currently, Ausmit authorised Payment Gateway Facility supports online bank transfers
					from the banks that are available while selecting the Prepay mode as the payment method.
					The AUSMIT TECHNOLOGY PRIVATE LIMITED may add or remove or suspend any one or
					more banks directly or through any payment gateway facilitators, and such change shall
					come into effect upon the same being posted on Ausmit.]</p> <br />
				<h2 class="heading">Eligibility</h2>
				<p>Ausmit or any service provided by Ausmit may only be used or accessed by such persons
					who can form legally binding contracts under Indian Contract Act, 1872. Persons who are
					‘incompetent to contract’ within the meaning of the Indian Contract Act, 1872 including
					minors, persons of unsound mind, and undischarged insolvent are not eligible to use
					Ausmit. A minor is not allowed to access or register as a User or sell or purchase any items
					on Ausmit.</p>
				<p>If you represent and are registering as a business entity, by accepting the User Agreement
					you represent that such entity has sufficient authority under applicable law to enter into the
					User Agreement and you are duly authorized by the business entity to accept this User
					Agreement and you have the authority to bind that business entity to this User Agreement.</p> <br />
				<h2 class="heading">Registration and Communication</h2>
				<p>By registering on Ausmit, you agree to allow us to contact you through
					any mode of communication (Email/Chat/Telephone call) for any conversation or service related
					information for the order placed by you, on the contact details provided by you. Any kind
					of legal implication raised, due to the incorrect nature of the details provided by you,
					Ausmit will not be held responsible for the same.</p>
				<p>You agree that your sole purpose of registering or using Ausmit is to buy or sell products
					including crafted and ethnic products or such products as may be specifically notified by
					the AUSMIT TECHNOLOGY PRIVATE LIMITED on the Website from time to time (that are
					permitted to be bought and sold under applicable law) and you shall not use Ausmit for
					any other purpose including for selling or buying products other than as mentioned above
					or products that are not allowed under applicable law to be sold or bought by you in any
					manner.</p>
				<p>You agree to provide true, accurate and complete information while registering or for any
					other purpose when prompted to do so on Ausmit. You are prohibited from
					misrepresenting your identity and agree not to represent yourself as another User or login/
					register using the identity of any other person. You are responsible to maintain and
					promptly update the information provided while registering or for any other purpose on
					Ausmit to ensure that the information provided by you is true, accurate, current and
					complete at all times. If you provide any information that is untrue, inaccurate, not current
					or incomplete or the AUSMIT TECHNOLOGY PRIVATE LIMITED has reasonable grounds to
					deduce that such information is untrue, inaccurate, not current or incomplete, or not in
					accordance with this User Agreement, the AUSMIT TECHNOLOGY PRIVATE LIMITED
					reserves the right to indefinitely suspend or terminate or block your use or access to
					Ausmit platform in any manner whatsoever.</p>

				<p> <span style="font-weight: bold;"> Buyer Registration: </span> Other than being a User, there is no
					separate
					registration requirement for buyers. Ausmit authorised Payment Gateway facility is available to
					Buyers who hold a
					Valid Card or Valid Bank Account.</p>

				<p> <span style="font-weight: bold;"> Electronic Communication:</span>You agree to keep yourself updated
					with all
					data, information and communication pertaining to you made available on Ausmit. You further agree
					that
					your use of Ausmit or provision of any data or information including any correspondence
					(by email or otherwise) to or by the AUSMIT TECHNOLOGY PRIVATE LIMITED is through
					electronic records and you consent to receive communication from the AUSMIT
					TECHNOLOGY PRIVATE LIMITED via electronic records which will be deemed adequate
					service of notice/ electronic record.</p> <br />

				<h2 class="heading">Terms of Use</h2>
				<p>You understand and agree that the AUSMIT TECHNOLOGY PRIVATE LIMITED merely
					provide hosting services to its Users who access Ausmit for purchase and sale of products
					(that are permitted to be bought and sold under applicable law). All items advertised
					and/or listed on Ausmit platform and the contents therein are advertised and listed by
					Users and are third party purchasers and/or brands as the case may be. You also give
					permission to the Website and the AUSMIT TECHNOLOGY PRIVATE LIMITED to store
					details and records of your usage of Au smit indefinitely. However, this does not constitute
					any obligation on the part of the AUSMIT TECHNOLOGY PRIVATE LIMITED or the Website
					to do so.</p>
				<p>Currently the membership on Ausmit is free and the AUSMIT TECHNOLOGY PRIVATE
					LIMITED does not levy any charges/fees for browsing or buying on Ausmit. However, for
					the purposes of listing any item on Ausmit to be sold or availing other services provided by
					the AUSMIT TECHNOLOGY PRIVATE LIMITED through Ausmit platform such as packing,
					warehousing, courier etc., the Brands will be charged fees as provided in the Facility
					Charges Policy incorporated herein by reference. The AUSMIT TECHNOLOGY PRIVATE
					LIMITED reserves the right to introduce new services or modify the existing services
					provided on Ausmit platform. Additionally, the AUSMIT TECHNOLOGY PRIVATE LIMITED at
					its sole discretion may introduce fees for the new services provided or amend/ introduce
					fees for the existing services, as the case may be. Changes to the User Agreement or any of
					the rules and policies of the AUSMIT TECHNOLOGY PRIVATE LIMITED shall be posted on
					Ausmit and such changes shall automatically become effective immediately after they are
					posted on Ausmit.</p>
				<p>All fees/ charges shall be quoted in Indian Rupees and shall be payable to Ausmit within
					such time as specified in the invoice. You are responsible for paying all charges/ fees
					associated with the use of Ausmit and shall be liable to pay any and all applicable taxes,
					charges, cesses etc. which may be levied. In case of any non- payment, the AUSMIT
					TECHNOLOGY PRIVATE LIMITED reserves the right to issue a warning or temporarily/
					indefinitely suspend or terminate your membership with Ausmit and disallow access to
					Ausmit. The AUSMIT TECHNOLOGY PRIVATE LIMITED also reserves the right to take any
					legal action against you in case of any non- payment of charges/fees to the AUSMIT
					TECHNOLOGY PRIVATE LIMITED.</p>
				<p>You agree that the AUSMIT TECHNOLOGY PRIVATE LIMITED may appoint any third party
					service provider, including but not restricted to one or more of the AUSMIT TECHNOLOGY
					PRIVATE LIMITED’s affiliate to provide backend operations and support as instructed by the
					AUSMIT TECHNOLOGY PRIVATE LIMITED from time to time including but not limited to
					collection, processing and remittance of the Transaction Price using the existing authorized</p>
				<p>banking infrastructure to provide enabling support facility for collection and remittance of
					payment including but not limited to the Logistics Partner.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED neither originates nor transmits any
					communication/ information on behalf of any User nor does it modify the contents of any
					communication transmitted. The AUSMIT TECHNOLOGY PRIVATE LIMITED has no control
					over third parties and contents generated by the Users on Ausmit.</p>
				<p>Any information provided by you to the AUSMIT TECHNOLOGY PRIVATE LIMITED or
					submitted to Ausmit or provide or display to other Users of Ausmit in the registration,
					buying or listing process, in the feedback area or through any e-mail communication is
					solely your responsibility and the AUSMIT TECHNOLOGY PRIVATE LIMITED merely is a
					platform where such information is distributed, published, displayed or used by Users. The
					AUSMIT TECHNOLOGY PRIVATE LIMITED or the Website is not liable for accuracy,
					appropriateness or legality of such information.</p> <br />

				<h2 class="heading">User Obligations</h2>
				<p>All contractual terms of the manner and terms & conditions of delivery, payment,
					insurance etc. between the buyer and the brands shall be independently agreed with the other users
					of Ausmit that you may transact with.</p>
				<p>You will treat Ausmit as a mere passive conduit which is used as a platform by Users to
					create listings or provide information for the purpose of selling their items so that such
					information can be discovered and read by other Users of Ausmit who may wish to
					purchase such items from other Users or provide feedback on items they have purchased
					or sellers who have sold any item to them.</p>
				<p>You agree and undertake not to host, display, upload, modify, publish, transmit, update or
					share any information or list any information or item that:</p> <br />

				<p>● belongs to another person and to which you do not have any right to;</p>
				<p>● is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic,
					paedophilic, libellous, invasive of another’s privacy, hateful, or racially, ethnically
					objectionable, disparaging, relating or encouraging money laundering or gambling, or
					otherwise unlawful in any manner whatever; or unlawfully threatening or unlawfully
					harassing including but not limited to “indecent representation of women” within the
					meaning of the Indecent Representation of Women (Prohibition) Act, 1986;</p>
				<p>● harm minors in any way;</p>
				<p>● infringes any patent, trademark, copyright or other proprietary rights or third party’s trade
					secrets or rights of publicity or privacy or shall not be fraudulent or involve the sale of
					counterfeit or stolen items;</p>
				<p>● violates any law for the time being in force;</p>
				<p>● deceives or misleads the addressee/ users about the origin of such messages or
					communicates any information which is grossly offensive or menacing in nature;</p>
				<p>● impersonate another person or use an anonymous proxy;</p>
				<p>● contains software viruses or any other computer code, files or programs designed to
					interrupt, destroy or limit the functionality of any computer resource; or contains any
					Trojan horses, worms, time bombs, cancelbots, Easter eggs or other computer</p>
				<p>● threatens the unity, integrity, defense, security or sovereignty of India, friendly relations
					with foreign states, or public order or causes incitement to the commission of any
					cognizable offence or prevents investigation of any offence or is insulting any other nation;</p>
				<p>● shall not be false, inaccurate or misleading;</p>
				<p>● shall not, directly or indirectly, offer, attempt to offer, trade or attempt to trade in any item,
					the dealing of which is prohibited or restricted in any manner under the provisions of any
					applicable law, rule, regulation or guideline for the time being in force;</p>
				<p>● may give rise to liability on part of the Website or the AUSMIT TECHNOLOGY PRIVATE
					LIMITED or cause any hindrance (in whole or in part) with respect to the services of ISPs or
					other suppliers of the Website or the AUSMIT TECHNOLOGY PRIVATE LIMITED; and</p>
				<p>● link directly or indirectly to or include descriptions of items that are (i) prohibited under the
					User Agreement or any other applicable law for the time being in force including but not
					limited to the Drugs and Cosmetics Act, 1940, the Drugs and Magic Remedies
					(Objectionable Advertisements) Act, 1954, the Indian Penal Code, 1860, Information
					Technology Act 2000 as amended time to time and rules there under or (ii) are at the same
					time listed for sale on a web site other than Ausmit. You shall not promote any website or
					webpage or link on Ausmit.
					In case of any violation of the above provisions, the AUSMIT TECHNOLOGY PRIVATE
					LIMITED has the right to immediately terminate the access or usage rights of the user to
					Ausmit without any notice and any such violating information that is displayed or
					submitted on Ausmit can be removed immediately and completely.</p>
				<p>You shall be responsible for keeping backup versions of the information and data provided
					by you. You hereby agree that you will not expect Ausmit to restore or keep back up of
					your information and data and not hold the Website or the AUSMIT TECHNOLOGY
					PRIVATE LIMITED accountable for any loss of data in any circumstances.</p>
				<p>You shall not, either alone or in conjunction with other users, manipulate or attempt to
					manipulate the prices of any item being sold or purchased on Ausmit. You will also refrain
					from accessing information or databases in an unauthorized manner from Ausmit or
					servers where information or databases are kept.</p>
				<p>You shall not attempt to or circumvent or manipulate any of the obligations conferred on
					you by this User Agreement. If such an attempt is discovered, it will constitute sufficient
					grounds for termination of access to Ausmit platform and also for taking appropriate legal
					action.</p>
				<p>In case of any transaction or attempted transaction pertaining to any item listed on Ausmit
					which is violating this User Agreement or applicable laws comes to your knowledge, you
					shall forthwith take all steps to inform the AUSMIT TECHNOLOGY PRIVATE LIMITED of
					such violation at customercare&#64;Ausmit.</p>
				<p>If you choose to provide feedback on Ausmit which is visible to other users, you shall
					exercise due care while making comments and not make any comments that are not
					factual in nature and shall not post defamatory or illegal or offensive/ obscene contents</p>
				<p>You undertake not to disclose or distribute any other User’s Information to a third party, or
					use the Information for any unauthorized purpose including for the purposes of marketing
					unless you have obtained the User’s express consent to do so.</p>
				<p>You shall not attempt to ‘double dip’ during the course of a dispute by receiving or
					attempting to receive funds from the AUSMIT TECHNOLOGY PRIVATE LIMITED and/or its
					service providers and/or the buyer or seller as the case maybe.</p> <br />
				<h2 class="heading">Disclaimers</h2>
				<p>All commercial / contractual terms are offered by and agreed to between buyers and
					sellers alone as per principal to principal bipartite contractual obligations. The commercial
					/ contractual terms include without limitation price, shipping costs, payment methods,
					payment terms, date, period and mode of delivery, warranties related to items listed for
					sale. The AUSMIT TECHNOLOGY PRIVATE LIMITED does not have any control and neither
					does it determine or advise or in any way involves itself in the offering or acceptance of
					such commercial / contractual terms between buyers and sellers. Further, you understand
					that a listing may end if another User buys the item, or the User who made the listing
					chooses to end the same or if the listing expires after a stipulated period of time.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED is neither involved in the buying and selling
					of items on the Website nor liable or responsible for any non- performance or breach of
					any contract entered into between the Users (i.e. buyer and seller) including but not limited
					to non-delivery or non-receipt, non-payment, damage, breach of representations and
					warranties provided by the seller or any fraud as regards the items listed on Ausmit. The
					Users acknowledge that the AUSMIT TECHNOLOGY PRIVATE LIMITED will not be liable for
					any damages, interests or claims etc. resulting from not processing or any delay in
					processing a Transaction/ Transaction Price which is beyond the control of the AUSMIT
					TECHNOLOGY PRIVATE LIMITED. The AUSMIT TECHNOLOGY PRIVATE LIMITED shall not
					and is not required to mediate or resolve any dispute or disagreement between users.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED does not make any representation or
					warranty as to the attributes (such as quality, worth, marketability, merchantability,
					usefulness) of the items proposed to be sold or offered to be sold or purchased on Ausmit.
					In particular, the AUSMIT TECHNOLOGY PRIVATE LIMITED does not implicitly or explicitly
					support or endorse the sale or purchase of any items on the Website. The AUSMIT
					TECHNOLOGY PRIVATE LIMITED shall not be liable for any errors or omissions, whether on
					behalf of itself or third parties.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED does not make any representation or
					warranty as to the attributes (such as legal title, creditworthiness, identity etc.) of any of its
					users. You are advised to use your best judgment and independently verify the bona fides
					of any particular User that you choose to deal with on Ausmit.</p>
				<p>Ausmit is only a venue through which Users can reach a larger base to buy and sell unique
					products. The AUSMIT TECHNOLOGY PRIVATE LIMITED is only providing a platform in
					form of the Website for communication and a hosting service for information and it is
					agreed that the contract for sale of any of the items shall be a strictly bipartite contract
					between the seller and the buyer. At no time shall any right, title or interest over the items
					vest with the AUSMIT TECHNOLOGY PRIVATE LIMITED nor shall the AUSMIT
					TECHNOLOGY PRIVATE LIMITED have any obligations or liabilities in respect of such
					contract. The AUSMIT TECHNOLOGY PRIVATE LIMITED is not responsible for
					unsatisfactory or delayed performance of sellers or damages or delays as a result of items
					being out of stock, back ordered or otherwise unavailable. All items offered by sellers are
					only for a restricted time and only for the available supply as offered by sellers.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED and its suppliers, affiliates and service
					providers make available Ausmit, Ausmit authorised Payment Gateway facility for
					electronic payment on an “as is” basis and without any warranty or condition, express,
					implied or statutory and specifically disclaim any implied warranties of title,
					merchantability, fitness for a particular purpose and non-infringement. The AUSMIT
					TECHNOLOGY PRIVATE LIMITED specifically disclaims any such warranty. You expressly
					agree that the use of Ausmit and Ausmit authorised payment gateway electronic payment
					facility is at your own risk.</p>
				<p>You release and indemnify the AUSMIT TECHNOLOGY PRIVATE LIMITED and/or any of its
					officers and representatives from any cost, damage, liability or other consequence of any
					of the actions of the users of Ausmit and specifically waive any claims that you may have in
					this behalf under any applicable law. The AUSMIT TECHNOLOGY PRIVATE LIMITED cannot
					control the information provided by other Users, which is made available on the Website
					notwithstanding the AUSMIT TECHNOLOGY PRIVATE LIMITED’s reasonable efforts in that
					behalf. You may find other User’s information to be offensive, harmful, inaccurate, or
					deceptive. Please use caution and practice safe trading when using the Website. Please
					note that there may be risks in dealing with foreign nationals, underage persons or people
					acting under false pretence.</p> <br />
				<h2 class="heading">Limited liability</h2>
				<p>In no event shall the AUSMIT TECHNOLOGY
					PRIVATE LIMITED or its suppliers, affiliates and
					service providers be liable for any direct, indirect, incidental, special, consequential or
					exemplary damages, including but not limited to, damages for loss of profits, goodwill, use,
					data or other intangible losses arising (in any manner whatsoever, including but not limited
					to negligence) out of or in connection with Ausmit, Ausmit authorised payment gateway
					facility, services provided by the Logistics Partner or any other services or this User
					Agreement.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED liability in any circumstance is limited to the
					amount of charges/ fees, if any, paid by you to the AUSMIT TECHNOLOGY PRIVATE
					LIMITED. The AUSMIT TECHNOLOGY PRIVATE LIMITED, its associates, affiliates and service
					providers and technology partners make no representations or warranties about the
					accuracy, reliability, completeness, and/or timeliness of any content, information, software,
					text, graphics, links or communications provided on or through the use of Ausmit or that
					the operation of Ausmit or the Logistics Partner or Ausmit authorised payment gateway
					facility will be error free and/or uninterrupted. The AUSMIT TECHNOLOGY PRIVATE
					LIMITED provides no guarantee to its Users in respect of the products sold on the Website.
					Consequently, the AUSMIT TECHNOLOGY PRIVATE LIMITED assumes no liability
					whatsoever for any monetary or other damage suffered by you on account of:</p> <br />

				<p>● The delay, failure, interruption, or corruption of any data or other information transmitted in
					connection with use of the Website or Ausmit authorised payment gateway facility.</p>
				<p>● Any delay, failure, interruption or errors in the operation of Ausmit or the Logistics Partner
					or Ausmit authorised payment gateway facility.</p>
				<p>● Indemnity
					You shall indemnify and hold harmless the AUSMIT TECHNOLOGY PRIVATE LIMITED and
					the AUSMIT TECHNOLOGY PRIVATE LIMITED’s parent, subsidiaries, affiliates, third-parties
					and their respective officers, directors, agents, and employees, from any claim or demand,
					or actions including reasonable attorneys’ fees, made by any third party or penalty
					imposed due to or arising out of your breach of the User Agreement including the rules andpolicies
					incorporated
					herein by reference, or (ii) your violation of any law, rules or
					regulations or the rights of a third party.</p> <br />
				<h2 class="heading">Payment</h2>
				<p>Payments for the items on Ausmit, at the option of the relevant seller, can be made by way
					of (i) Payment on Billing which can be made through the Ausmit authorised payment
					gateway Facility or by depositing cash, cheque, demand draft in the bank account of the
					AUSMIT TECHNOLOGY PRIVATE LIMITED; or (ii) Payment on Delivery wherein payment
					shall be made only by cash on delivery, or such other method of payment as may be
					permitted by the AUSMIT TECHNOLOGY PRIVATE LIMITED on Ausmit in its sole discretion.</p>
				<p>For the purposes of buying and/or selling any item listed on Ausmit, you agree and
					undertake not to make payments in any manner other than as provided, without the prior
					consent of the AUSMIT TECHNOLOGY PRIVATE LIMITED.</p>
				<p>You acknowledge and accept that you have specifically authorized the AUSMIT
					TECHNOLOGY PRIVATE LIMITED to collect, process, facilitate and remit payments and/ or
					the Transaction Price by any of the prescribed methods of payment through Payment on
					Billing or Payment on Delivery to and from other Users in respect of Transactions.</p>
				<p>In order to enable Users to carry out transactions on Ausmit, the AUSMIT TECHNOLOGY
					PRIVATE LIMITED will in addition to other methods of payment provide an electronic
					payment facility i.e. Ausmit authorised payment gateway facility by Razorpay on the
					Website. The Ausmit authorised payment gateway facility enables automated collection
					and remittance services using the facilities of various Indian banks, financial institutions,
					credit/ debit/ cash card brands, various third party service providers and/or payment card
					industry issuers and through such other infrastructure and facilities as may be authorized
					by the Reserve Bank of India for collection, refund and remittance, as the case may be. The
					Ausmit authorised payment gateway facility shall be availed in accordance with the terms
					of this User Agreement and the rules and policies prescribed hereunder.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED shall make reasonable efforts to ensure that
					requests for electronic debits and credits involving Issuing Bank are informed to the Nodal
					Bank (defined below) in a timely manner. However, a number of factors that are outside of
					the AUSMIT TECHNOLOGY PRIVATE LIMITED’s control (including without limitation actions
					of Issuing Bank, Nodal Bank and the bank or credit / debit/ cash card and/or banks or
					financial institution infrastructure or indirectly through payment gateway facility providers
					or through any such facility authorized by the Reserve Bank of India to provide enabling
					support facility for collection and remittance of payment where the Transaction Price is
					remitted and/or refunded) may delay the time within which the Transaction Price are
					collected/ remitted by the AUSMIT TECHNOLOGY PRIVATE LIMITED through the Ausmit
					authorised payment gateway facility. The AUSMIT TECHNOLOGY PRIVATE LIMITED neither
					makes any representations nor makes any warranties regarding the amount of time needed
					to complete processing, including delays in the banking system and nor shall the AUSMIT
					TECHNOLOGY PRIVATE LIMITED be liable for any actual or consequential damages arising
					from any claim of delay.</p>
				<p>Any claim for refund of any payment made to the AUSMIT TECHNOLOGY PRIVATE
					LIMITED, for any reason whatsoever, shall be to the account of the Seller and the AUSMIT
					TECHNOLOGY PRIVATE LIMITED shall not be responsible for the same including but not
					limited to service charges or any other fees/ charges.</p>
				<p>You agree and accept that the AUSMIT TECHNOLOGY PRIVATE LIMITED is neither acting as
					trustee nor acting in a fiduciary capacity with respect to the Transaction or the Transaction
					Price, by providing the Ausmit authorised payment gateway facility or any other method of
					payment to its Users.</p> <br />
				<h2 class="heading">Consent and Privacy Policy</h2>
				<p>By using Ausmit and/or by providing your information, you consent to the
					collection and
					use of such information disclosed by you on Ausmit on Ausmit authorised payment
					gateway facility, by the AUSMIT TECHNOLOGY PRIVATE LIMITED. The personal
					information / data including but not limited to the Information provided by the You to
					Ausmit/ Ausmit authorised payment gateway facility during the course of a Transaction
					shall be treated as strictly confidential and retained in accordance with the Privacy
					Policy which is incorporated herein by reference and applicable laws and regulations
					including but not limited to Information Technology Act, 2000 and rules there under. The
					AUSMIT TECHNOLOGY PRIVATE LIMITED does not sell or rent or otherwise disclose your
					personal information to third parties for their marketing purposes without your explicit
					consent and the AUSMIT TECHNOLOGY PRIVATE LIMITED only uses your information in
					the manner described in the Privacy Policy. If you do not agree to your Information being
					transferred or used in this way, please do not use Ausmit.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED views the protection of user’s privacy as a
					very important community principle. The AUSMIT TECHNOLOGY PRIVATE LIMITED clearly
					understands that you and the personal information provided by you is one of the most
					important assets to the AUSMIT TECHNOLOGY PRIVATE LIMITED. The AUSMIT
					TECHNOLOGY PRIVATE LIMITED stores and processes the information provided by you in
					computers located in India that are protected by physical as well as reasonable
					technological security measures and procedures in compliance with the provisions of the
					Information Technology Act, 2000 and rules made thereunder.</p> <br />

				<h2 class="heading">Breach</h2>
				<p>Without limiting other remedies that the AUSMIT TECHNOLOGY PRIVATE LIMITED may
					pursue, the AUSMIT TECHNOLOGY PRIVATE LIMITED may at its sole discretion take such
					action as it deems fit including but not limited to cancellation of the Transaction or
					payments made, limit your activity, immediately remove your information or listings, or
					end your listing, warn other Users of your actions, forthwith temporarily/indefinitely
					suspend or terminate or block your membership, and/or refuse to provide you with access
					to Ausmit or initiate any legal action it may deem fit, particularly in the event:</p> <br />

				<p>● You breach any of the provisions of this User Agreement including any of the rules and
					policies, documents, terms and conditions made thereunder which are incorporated
					therein by reference;</p>
				<p>● Any misuse of the Ausmit authorised payment gateway facility</p>
				<p>● The AUSMIT TECHNOLOGY PRIVATE LIMITED is unable to verify or authenticate any
					information provided by you;</p>
				<p>● The AUSMIT TECHNOLOGY PRIVATE LIMITED believes that your actions may cause legal
					liability to the AUSMIT TECHNOLOGY PRIVATE LIMITED, other Users or yourself. No
					actions, omissions or decisions taken by the AUSMIT TECHNOLOGY PRIVATE LIMITED shall
					waive any rights or claims that the AUSMIT TECHNOLOGY PRIVATE LIMITED may have
					against the User.
					No actions, omissions or decisions taken by the AUSMIT TECHNOLOGY PRIVATE LIMITED
					shall waive any rights or claims that the AUSMIT TECHNOLOGY PRIVATE LIMITED may
					have against the User.</p>
				<p>Any User that may have been suspended or blocked may not register or attempt to register
					with Ausmit or use Ausmit in any manner whatsoever until such time that such User is
					reinstated by the AUSMIT TECHNOLOGY PRIVATE LIMITED. Notwithstanding the above, if
					you breach the User Agreement or the rules and policies and other documents
					incorporated therein by reference, the AUSMIT TECHNOLOGY PRIVATE LIMITED reserves
					the right to recover any amounts due and owed by you to the AUSMIT TECHNOLOGY
					PRIVATE LIMITED and to take strict legal action including but not limited to referral to the
					appropriate police or other authorities for initiating criminal or other proceedings against
					me.</p> <br />

				<h2 class="heading">Grievance Redressal Mechanism</h2>
				<p>In case of any grievance, objection or complaint on your part with respect
					to the Website,
					other Users, Ausmit authorised payment gateway facility or the AUSMIT TECHNOLOGY
					PRIVATE LIMITED, including any complaints or enquiry about suspension, termination or
					blocking of your membership or right to use Ausmit, you should promptly raise such
					grievance or complaint with Ausmit by sending mail to privacy&#64;ausmit.in and provide with
					all necessary information and/or documents to enable the AUSMIT TECHNOLOGY PRIVATE
					LIMITED to resolve the issue.</p> <br />

				<h2 class="heading">General</h2>
				<p>None of the provisions of this User Agreement shall be deemed to constitute a partnership
					or agency between you and the AUSMIT TECHNOLOGY PRIVATE LIMITED and you shall
					have no authority to bind the AUSMIT TECHNOLOGY PRIVATE LIMITED in any manner
					whatsoever.</p>
				<p>Except as explicitly stated otherwise, any notices directed to the AUSMIT TECHNOLOGY
					PRIVATE LIMITED shall be given by email to privacy&#64;ausmit.in and any notices to you by
					the AUSMIT TECHNOLOGY PRIVATE LIMITED shall be provided to the email address
					provided by you during the registration process. Notice shall be deemed given 24 hours
					after email is sent, unless the sending party is notified that the email address is invalid.
					Alternatively, we may give you notice by registered mail, postage prepaid and return
					receipt requested, to the address provided to us during the registration process. In such
					case, notice shall be deemed given 3 days after the date of mailing.</p>
				<p>If any clause of this User Agreement or the application thereof to any User or circumstance
					shall be deemed invalid, void or for any reason unenforceable to any extent, the remainder
					of this User Agreement and the application of such unenforceable provision to Users or
					circumstances other than those as to which it is held invalid or unenforceable shall not be
					affected thereby, and each provision of this User Agreement shall be valid and enforceable
					to the fullest extent permitted by law.</p>
				<p>This User Agreement together with the rules and policies incorporated herein by reference
					constitutes the entire understanding and agreement between You and the AUSMIT
					TECHNOLOGY PRIVATE LIMITED with respect to the subject matter herein.</p>
				<p>The AUSMIT TECHNOLOGY PRIVATE LIMITED at its sole discretion shall be entitled to
					assign or transfer its rights and obligations under this User Agreement hereunder to any
					other person without your prior consent provided that the AUSMIT TECHNOLOGY PRIVATE
					LIMITED assigns this User Agreement on the same terms or such terms that are no less
					favourable to you.</p>
				<p>All remedies of the AUSMIT TECHNOLOGY PRIVATE LIMITED under this User Agreement
					whether provided herein or conferred by statute, civil law, common law, custom or trade
					usage, are cumulative and not alternative and may be enforced successively or
					concurrently.</p> <br />

				<h2 class="heading">Arbitration</h2>
				<p>If any dispute arises between you and the AUSMIT TECHNOLOGY PRIVATE LIMITED during
					your use of Ausmit or the Ausmit authorised payment gateway facility or Ausmit Services
					or any service incidental to the Website or thereafter, in connection with the validity,
					interpretation, implementation or alleged breach of any provision of the User Agreement
					and/or Ausmit authorised payment gateway Agreement, or the rules, policies and
					documents incorporated therein by reference, the dispute shall be referred to a sole
					arbitrator who shall be an independent and neutral third party identified by the AUSMIT
					TECHNOLOGY PRIVATE LIMITED whose decision shall be final. The place of arbitration
					shall be Chennai (Tamil Nadu). The Arbitration & Conciliation Act, 1996, shall govern the
					arbitration proceedings. The arbitration proceedings shall be in the English language.</p> <br />

				<h2 class="heading">Governing Law</h2>
				<p>This User Agreement and all rules, policies and documents incorporated by reference shall
					be governed and construed in accordance with the laws of India and the Courts in Chennai
					(Tamil Nadu) shall have exclusive jurisdiction. This document is an electronic record in
					terms of Information Technology Act, 2000 and the amended provisions pertaining to
					electronic records in various statutes as amended by the Information Technology Act,
					2000. This electronic record is generated by a computer system and does not require any
					physical or digital signatures. </p>
				<h2 class="heading">Contact Us</h2>
				<p>In order to resolve a complaint regarding the Services or to receive further information regarding
					use
					of the Services, please contact us at: customercare&#64;ausmit.in</p>
				<div class="col-sm-12 text-center terms-condition-footer">
					<button mat-button class="accept-btn"
						(click)="form.controls.tnc.setValue(true);termAndConditionBlock = false">
						Accept
					</button>
					<button mat-button class="decline-btn" (click)="onDeclineClick()">Decline</button>
				</div>
			</div>

		</ng-container>
	</div>
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 image-container">
		<img src="assets/images/side-image.png" alt="brand-image" />
	</div>
</div>
<div class="footer">
	<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 px-0">
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 block-1">
			<p>Already have account?
				<a [routerLink]="['/login']">
					<strong>&nbsp;Login</strong>
				</a>
			</p>
		</div>
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 text-right block-2">
			<a [routerLink]="['/termsandconditions']">Terms & Conditions</a>
			<span>|</span>
			<a [routerLink]="['/privacypolicy']">Privacy Policy</a>
		</div>
	</div>
</div>